module.exports = __webpack_public_path__ + "img/ch13_06_兜兜重逢.c4e3060c.jpg";